export default __webpack_public_path__ + "static/media/Lost_online.8f199481.svg";